module.exports = __webpack_public_path__ + "img/pagbank-success.b1fd0ec5.png";